module.exports = __webpack_public_path__ + "static/media/substitution_in.dea32451.svg";